import React from "react";
import { BsChevronDown } from "react-icons/bs";
const Dropablebutton = () => {
  return (
    <div className="flex text-sm w-36 items-center justify-center h-8 text-center py-1.5 border rounded hover:text-blue-700 hover:border-blue-600">
      <button className="">Apollo Guide</button>
      <BsChevronDown className="ml-3" />
    </div>
  );
};

export default Dropablebutton;
